export default {
    cta: "Chiedi a un<br/> Consulente",
    ordered: "Ordinato il {date}"
}